import React from 'react'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import MediaModal from './MediaModal'
import { VideoModalStyle } from '../styles'

const config = {
    Icon: PlayArrowIcon,
    style: VideoModalStyle,
    favouriteType: 'video',
    resourcePath: 'videos',
    authorsLabel: 'Channel:',
    subKey: 'sub_videos',
    subHeading: 'Playlist',
    rowKeyPrefix: 'sub_video',
}

const VideoModal = (props) => <MediaModal config={config} {...props} />

export default VideoModal
